import React, { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import CardHeader from '@mui/material/CardHeader';
import { TextField } from '@material-ui/core';
import { verifyFirstLogin, isSessionExpired, setSessionActive, clearStoragePortal, setPasswordFull, setPasswordDefault, tokenExpired } from '../../api/services/AuthService'
import Alert from '@mui/material/Alert';
import aviao from '../../../assets/images/aviao.jpg';
import { Link, useNavigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../../theme/Theme';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import AirlinesIcon from '@mui/icons-material/Airlines';
import Grid from '@mui/material/Grid';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';


import styled from "styled-components";

import LoginService from '../../api/services/LoginService';

const DivLogin = styled.div`
    background-image:url(${aviao});  
    position:fixed;
    z-index:0;
    width:100%;
    height:100%;
    background-attachment: fixed;
    background-size: cover;
    background-position: right top;
    overflow:auto;
`

const CardLogin = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index:2;
    opacity:0.9;
`

const Titulo = styled(Typography)`
    align-items: center;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    display: flex;
    position:relative;
    z-index:2; 
    color:white;
    font-family: "Lucida Sans" !important;
    color:#800000;

`

const CardHeaderLogin = styled(CardHeader)`
    background-color:#9A294B;
    color:white;
    font-height:bold;
    height:50px;
`

const AlertBadCredentials = styled(Alert)`
    margin-bottom:5px;
    display: ${({ isvisible }) => isvisible === 'true' ? 'flex !important' : 'none !important'}
`

const LinkMenu = styled(Link)`
    margin: 0;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5;
    letter-spacing: 0.00938em;
    display: block;
    color: inherit;
    text-decoration:none;
`
export default function Login() {
    const [showPassword, setShowPassword] = useState(false);
    const [showCode, setShowCode] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [firstToken, setFirstToken] = useState("");
    const [code, setCode] = useState("");
    const [error, setError] = useState(false);
    const [variant, setVariant] = useState("error");
    const [message, setMessage] = useState("");
    const [open, setOpen] = useState(false);

    let navigate = useNavigate();

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleClickShowCode = () => setShowCode((show) => !show);

    const handleMouseDownCode = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        const statusSessionExpired = () => {
            setVariant("warning");
            setMessage('Sessão Encerrada!');
            setError(true)
            clearStoragePortal();
        }
        if (error !== true && isSessionExpired() === true) {
            statusSessionExpired();
        }

    }, [variant, message, error]);

    const servico = new LoginService();

    const restart = () => {
        setFirstToken("");
        setCode("");
        setError(false);
    }

    const login = () => {
        if (!firstToken) firstLevelAuthentication();
        else secondLevelAuthentication();
    }

    const secondLevelAuthentication = () => {
        setOpen(true);
        setError(false)
        if (tokenExpired(firstToken)) {
            servico.authenticateSecondLevel(username, password, code, firstToken).then(response => {
                servico.clearStorage();
                const jsonToken = response.data;
                let user = verifyFirstLogin(jsonToken);
                setSessionActive();
                if (user.isReset) {
                    setPasswordFull();
                    if (user.isAdmin || user.isSuperAdmin) {
                        navigate('/fatura');
                        navigate(0);
                    } else {
                        navigate('/dashboard');
                        navigate(0);
                    }
                } else {
                    setPasswordDefault();
                    navigate('/redefinirSenha', { replace: true, state: { initReset: true } });
                    navigate(0);
                }
            }).catch(erro => {
                setError(true);
                setVariant("error");
                if (erro.code === 401) setMessage(erro.message)
                else {
                    switch (erro?.response?.status) {
                        case 401 || 403:
                            setMessage("Código de Acesso Inválido!")
                            break;
                        default:
                            setMessage("Problema ao tentar logar, entre em contato com o adm do sistema!")
                            break;
                    }
                }
            }).finally(() => {
                setOpen(false);
            })
        } else {
            setError(true);
            setVariant("error");
            setMessage("Código de Acesso Expirado! Recomece o processo de login!");
            setOpen(false);
        }
    }

    const firstLevelAuthentication = () => {
        setOpen(true);
        setError(false)
        servico.authenticateFirstLevel(username, password).then(response => {
            setFirstToken(response.data);
            setError(true);
            setVariant("success");
            setMessage("Credenciais Validadas. O código de acesso, com validade de 15 minutos, foi enviado ao seu email.")
        }).catch(erro => {
            setError(true);
            setVariant("error");
            if (erro.code === 401) setMessage(erro.message)
            else {
                switch (erro?.response?.status) {
                    case 401 || 403:
                        setMessage("Credenciais Inválidas!")
                        break;
                    default:
                        setMessage("Problema ao tentar logar, entre em contato com o adm do sistema!")
                        break;
                }
            }
        }).finally(() => {
            setOpen(false);
        })
    }

    return (
        <>
            <ThemeProvider theme={theme}>
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <DivLogin>
                    <CardLogin>
                        <Titulo variant="h3" gutterBottom>
                            <AirlinesIcon sx={{ fontSize: 50, color: "black" }}></AirlinesIcon>ÁREA DO AGENTE
                        </Titulo>
                        <Card variant="outlined" style={{ width: "550px" }}>
                            <CardHeaderLogin title="LOGIN" />
                            <CardContent>
                                <TextField
                                    id="username"
                                    disabled={firstToken}
                                    autoComplete="off"
                                    label="Usuário"
                                    type="text"
                                    margin="normal"
                                    variant="outlined"
                                    fullWidth
                                    required
                                    placeholder="Usuário"
                                    hiddenLabel
                                    value={username}
                                    onChange={(event) => {
                                        setUsername(event.target.value);
                                    }}
                                />
                                <TextField
                                    label='Password'
                                    variant="outlined"
                                    fullWidth
                                    required
                                    type={showPassword ? "text" : "password"} // <-- This is where the magic happens
                                    onChange={(event) => {
                                        setPassword(event.target.value);
                                    }}
                                    InputProps={{ // <-- This is where the toggle button is added.
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                >
                                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                                {firstToken ?
                                    <TextField
                                        label='Código de Verificação'
                                        variant="outlined"
                                        sx={{ marginTop: 1 }}
                                        fullWidth
                                        required
                                        type={showCode ? "text" : "password"}
                                        onChange={(event) => {
                                            setCode(event.target.value);
                                        }}
                                        InputProps={{ // <-- This is where the toggle button is added.
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowCode}
                                                        onMouseDown={handleMouseDownCode}
                                                    >
                                                        {showCode ? <Visibility /> : <VisibilityOff />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                    : null}
                                <AlertBadCredentials sx={{ marginTop: 1 }} isvisible={error.toString()} variant="filled" severity={variant}>
                                    {message}
                                </AlertBadCredentials>
                                <Grid container spacing={2} style={{ marginTop: 5, marginBotton: '1em' }}>
                                    <Grid item xs={6}>
                                        <Button onClick={login} type="submit" variant="contained" color="primary">
                                            Logar
                                        </Button>
                                        {firstToken ?
                                            <Button onClick={restart} style={{ marginLeft: "10px" }} variant="contained" color="primary">
                                                Recomeçar
                                            </Button>
                                            : null}
                                    </Grid>
                                    <Grid item xs={6}>
                                        <LinkMenu to='/recuperarSenha'>
                                            <ListItem>
                                                <ListItemText sx={{ color: "#9A294B", textAlign: "right" }} primary={"Esqueci minha senha"} color='primary' />
                                            </ListItem>
                                        </LinkMenu>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </CardLogin>
                </DivLogin>
            </ThemeProvider>
        </>
    );
}